import { Footer, Header } from 'components';
import { useDispatch, useSelector } from 'react-redux';
import { initApp } from 'actions/auth.actions';
import { HOME_ROUTE, LOGIN_AUTH } from 'constants/routeNames';
import './Sistemas.scss';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { Spin, Typography } from 'antd';
import ButtonWithHover from 'components/ButtonWithHover/ButtonWithHover';
import { selectMenuLoadState } from 'selectors/auth.selector';
import { selectMenuSistemasState } from 'selectors/autenticacion.selector';
import { getMenuSistemasWeb } from 'actions/autenticacion.actions';
import Cookie from 'universal-cookie';
import { COOKIE_JWT_TOKEN_SIMAC } from 'constants/cookies';

const { Text } = Typography;
const cookie = new Cookie();
let token = '';

// let newWindow = null;
const urlMenuSelected = process.env.REACT_APP_OPEN_VIGAP;

const Sistemas = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { loading } = useSelector(selectMenuLoadState);
  const { data: menuSistemas } = useSelector(selectMenuSistemasState);

  const openWindow = () => {
    if (window.vigap && !window.vigap.closed) {
      window.vigap.focus();
    } else {
      window.vigap = window.open(urlMenuSelected, '_blank');
    }
    // window.vigap = window.open(`${urlMenuSelected}/vigap/home`, '_blank');
  };

  const handleSendMessage = (event) => {
    if (event.origin === urlMenuSelected) {
      const { tipo } = event.data;
      if (tipo === 'pageLoaded') {
        window.vigap.postMessage({ tipo: 'token', contenido: token }, urlMenuSelected);
        // console.log('tipo y token', tipo, token);
      } else if (tipo === 'reloadedSimac') {
        // console.log('mensaje reloaded');
        window.vigap.close();
        window.location.reload();
      }
    }
  };

  const handleCloseWindow = (event) => {
    if (event.origin === urlMenuSelected) {
      const { tipo } = event.data;
      if (tipo === 'Close') {
        // console.log('Cerrando VIGAP...');
        window.vigap.close();
      }
    }
  };

  const redirectMenu = (urlMenu) => {
    switch (urlMenu) {
      case '/centralSimac/cargaPortal':
        navigate(HOME_ROUTE);
        break;
      default:
        try {
          token = cookie.get(COOKIE_JWT_TOKEN_SIMAC);
          openWindow();
        } catch (error) {
          console.log('Falló el cambio de dominio', error);
        }
    }
  };

  useEffect(() => {
    window.addEventListener('message', handleSendMessage);
    window.addEventListener('message', handleCloseWindow);
  }, []);

  useEffect(() => {
    const respuesta = async () => {
      const { success } = await dispatch(initApp());
      if (success !== 200) {
        if (!process.env.REACT_APP_IS_LOCAL) {
          window.location.href = 'process.env.REACT_IS_NOT_LOCAL';
        }
        // window.location.href = 'https://sifv6-test.ine.mx/loginUTF/'; // pruebas
        // window.location.href = 'https://sifv6-usu-test.ine.mx/loginUTF/'; // usu
      }
      if (success !== 200) {
        const ruta = LOGIN_AUTH;
        navigate(ruta);
      }
    };
    respuesta();
    dispatch(getMenuSistemasWeb());
  }, []);

  return (
    <div>
      <Header option="menuSistemas" />
      <div className="contenedorMenu">
        <div className="bienvenida">
          <Text className="titulo">¡Te damos la bienvenida!</Text>
          <Text className="informacion">Haz clic en el sistema para ingresar</Text>
        </div>
        <div className="contenedorSistemas">
          {loading ? (
            <Spin size="default" />
          ) : (
            menuSistemas?.map((button) => (
              <ButtonWithHover
                key={button.sistema}
                normalImage={`data:image/png;base64,${button.img_b64}`}
                hoverImage={`data:image/png;base64,${button.img_hover_b64}`}
                onClick={() => redirectMenu(button.rutaSistema)}
              />
            ))
          )}
        </div>
      </div>
      <Footer view="sistemas" />
    </div>
  );
};

export default Sistemas;
